import { useEffect, useState } from "react";
import api from "../api/api";
import { useParams, useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FaFire, FaTag } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";


export default function RoomDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [room, setRoom] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [activeImage, setActiveImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);
    const [showBookingModal, setShowBookingModal] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [guests, setGuests] = useState(1);
    const [bookingLoading, setBookingLoading] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const today = new Date().toISOString().split("T")[0];
    const selectedDate = checkIn || today;
    const { hotelSlug, roomId } = useParams();



    useEffect(() => {
        document.body.style.overflow = showBookingModal ? "hidden" : "auto";
    }, [showBookingModal]);



    // useEffect(() => {
    //     console.log("ROOM DATA 👉", room);
    // }, [room]);

    useEffect(() => {
        const fetchRoom = async () => {
            try {
                const res = await api.get(`/rooms/${roomId}`);

                setRoom(res.data);



                setActiveImage(res.data.image);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchRoom();
    }, [roomId]);



    if (loading) {
        return (
            <FeaturedLoader
                title="Loading room details"
                subtitle="Fetching best available prices..."
            />
        );
    }


    if (error || !room) {
        return (
            <div className="h-screen flex flex-col justify-center items-center bg-white dark:bg-gray-950">
                <p className="text-red-500 text-lg">Room not found</p>
                <button onClick={() => navigate(-1)} className="mt-3 text-[#B89442]
dark:text-[#B89442]">
                    Go Back
                </button>
            </div>
        );
    }

    let images = [];
    try {
        images = room.images ? JSON.parse(room.images) : [];
    } catch {
        images = [];
    }

    const amenities = room.amenities ? JSON.parse(room.amenities) : [];

    const allImages = [room.image, ...images];

    const user = JSON.parse(localStorage.getItem("user"));



    const getOriginalPrice = () => {
        return Number(room?.price || 0);
    };

    const getNights = () => {
        if (!checkIn || !checkOut) return 1;

        const start = new Date(checkIn);
        const end = new Date(checkOut);

        const diffTime = end - start;

        const nights = Math.ceil(
            diffTime / (1000 * 60 * 60 * 24)
        );

        return nights > 0 ? nights : 1;
    };

    const getBookingTotal = () => {
        return nightlyRate * getNights();
    };

    const getTourismFee = () => {
        return Number(room?.hotel?.rating) === 5 ? 20 : 10;
    };



    const getFinalPriceBreakdown = () => {
        const base = nightlyRate;
        const nights = getNights();

        const serviceCharge = 0.10;
        const vat = 0.05;

        const tourismFee = getTourismFee();

        const taxRate = serviceCharge + vat;

        const nightlyWithTax = base + (base * taxRate) + tourismFee;

        const total = Math.round(nightlyWithTax * nights);

        return {
            base,
            nights,
            serviceCharge,
            vat,
            tourismFee,
            nightlyWithTax,
            total
        };
    };


    const handleBooking = async () => {

        if (!name || !email || !phone || !checkIn || !checkOut) {
            alert("Please fill all fields");
            return;
        }

        if (new Date(checkOut) <= new Date(checkIn)) {
            alert("Check-out must be after Check-in");
            return;
        }

        if (!executeRecaptcha) {
            alert("Captcha not ready. Refresh page.");
            return;
        }

        try {
            setBookingLoading(true);

            const token = await executeRecaptcha("room_booking");

            // BUILD DATA OBJECT
            const bookingData = {
                user_id: user?.id,
                hotel_id: room?.hotel?.id ?? room?.hotel_id,
                room_id: room.id,
                room_name: room.name || `Room ${room.room_number}`,

                room_price: room.price,
                discount_price: room.discount_price || null,

                name,
                email,
                phone,

                check_in: checkIn,
                check_out: checkOut,
                guests,
                season_name: activeSeason?.season_name || null,
                season_start: activeSeason?.start_date || null,
                season_end: activeSeason?.end_date || null,

                total_amount: getFinalPriceBreakdown().total,
                nights: getNights(),

                captcha: token
            };

            const res = await api.post("/hotel-payment", bookingData);

            if (res.data.payment_url) {
                window.location.href = res.data.payment_url;
            } else {
                alert("❌ Payment URL not received");
            }

        } catch (err) {
            if (err.response) {
                alert(`❌ ${err.response.data.error || err.response.data.message}`);
            } else {
                alert("❌ Server error");
            }

        } finally {
            setBookingLoading(false);
        }
    };



    const getRoomPrice = (room) => {
        return room?.discount_price
            ? Number(room.discount_price)
            : Number(room.price);
    };

    const getFinalRoomPrice = (room) => {
        const breakdown = getFinalPriceBreakdown();
        return Math.round(breakdown.nightlyWithTax);
    };

    const roundPrice = (value) => {
        return Math.round(Number(value));
    };

    const todayDate = new Date();

    const isDiscounted =
        room?.discount_price &&
        Number(room.discount_price) < Number(room.price);


    const activeSeason = room?.seasonal_prices?.find(season => {

        // use check-in date if selected
        // otherwise use today's date
        const date = checkIn
            ? new Date(checkIn)
            : new Date();

        return date >= new Date(season.start_date) &&
            date <= new Date(season.end_date);
    });



    const nightlyRate = (() => {
        if (!room) return 0;

        // Start with original price
        let finalPrice = Number(room.price);

        // Apply seasonal price first
        if (room.seasonal_prices?.length > 0) {
            const date = new Date(selectedDate);

            const match = room.seasonal_prices.find(season => {
                const start = new Date(season.start_date);
                const end = new Date(season.end_date);

                return date >= start && date <= end;
            });

            if (match) {
                finalPrice = Number(match.price);
            }
        }

        // Apply discount AFTER seasonal
        if (
            room.discount_price &&
            Number(room.discount_price) < finalPrice
        ) {
            finalPrice = Number(room.discount_price);
        }

        return finalPrice;
    })();



    const savedAmount = isDiscounted
        ? Number(room.price) - Number(room.discount_price)
        : 0;

    const discountPercent = isDiscounted
        ? Math.round(((room.price - room.discount_price) / room.price) * 100)
        : 0;





    const isSeasonal = activeSeason && activeSeason.price;


    const theme = {
        primary: "text-[#B89442] dark:text-cyan-400",
        primaryBg: "bg-blue-600 dark:bg-cyan-500",
        primaryBorder: "border-blue-200 dark:border-cyan-800",

        card: `
        bg-white dark:bg-gray-900
        border border-[#DDD2BA] dark:border-gray-800
        shadow-[0_10px_30px_rgba(0,0,0,0.08)]
        dark:shadow-[0_10px_30px_rgba(0,0,0,0.35)]
    `,

        soft: `
        bg-gradient-to-r
        from-blue-50
        to-cyan-50
        dark:from-gray-900
        dark:to-gray-900
        border border-blue-100
        dark:border-gray-800
    `,

        button: `
        bg-gradient-to-r
        from-blue-600
        via-cyan-500
        to-blue-700
        hover:opacity-90
        text-white
    `
    };


    return (


        <>
            <Helmet>
                {/* Basic SEO */}
                <title>
                    {room.meta_title || `${room.name} | UAE Dubai Hotels`}
                </title>

                <meta
                    name="description"
                    content={
                        room.meta_description ||
                        room.short_description ||
                        room.description ||
                        `${room.name} at ${room.hotel?.name}. Book this room at the best available price with UAE Dubai Hotels.`
                    }
                />

                {room.meta_keywords && (
                    <meta name="keywords" content={room.meta_keywords} />
                )}

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Dubai Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href={`https://uaedubaihotels.com/hotels/${room.hotel?.slug}/${room.id}`}
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Dubai Hotels" />
                <meta property="og:locale" content="en_US" />

                <meta
                    property="og:title"
                    content={room.meta_title || `${room.name} | UAE Dubai Hotels`}
                />

                <meta
                    property="og:description"
                    content={
                        room.meta_description ||
                        room.short_description ||
                        room.description ||
                        `Book ${room.name} at ${room.hotel?.name} with UAE Dubai Hotels for the best available rates.`
                    }
                />

                <meta
                    property="og:url"
                    content={`https://uaedubaihotels.com/hotels/${room.hotel?.slug}/${room.id}`}
                />

                <meta
                    property="og:image"
                    content={
                        room?.image
                            ? `https://uaedubaihotels.com/uploads/rooms/${room.image}`
                            : "https://uaedubaihotels.com/images/default-og.png"
                    }
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content={room.meta_title || `${room.name} | UAE Dubai Hotels`}
                />

                <meta
                    name="twitter:description"
                    content={
                        room.meta_description ||
                        room.short_description ||
                        room.description ||
                        `Explore and book ${room.name} at ${room.hotel?.name} with UAE Dubai Hotels.`
                    }
                />

                <meta
                    name="twitter:image"
                    content={
                        room?.image
                            ? `https://uaedubaihotels.com/uploads/rooms/${room.image}`
                            : "https://uaedubaihotels.com/images/default-og.png"
                    }
                />
            </Helmet>

            <div className="min-h-screen bg-[#FCFAF5] dark:bg-gray-950">
                <div
                    className="
        max-w-7xl mx-auto
        px-4 sm:px-6 lg:px-8
        py-8
        sm:py-10
        lg:py-14
        text-gray-900
        dark:text-gray-100
        pb-10
    "
                >

                    {/* 🔹 BREADCRUMB */}
                    {/* ================= TOP NAV + HERO + GALLERY ================= */}


                    {/* 🔹 TOP BAR */}
                    <div className="
    flex
    flex-col
    sm:flex-row
    sm:items-center
    sm:justify-between
    gap-4
">

                        {/* Breadcrumb */}
                        <div className="
        flex 
        items-center 
        gap-2 
       text-xs
sm:text-sm
        text-gray-500 
        dark:text-gray-400
    ">

                            <button
                                onClick={() => navigate("/")}
                                className="
                text-[#0F766E]
                hover:text-[#B89442]
                dark:text-[#B89442]
                transition
                font-medium
            "
                            >
                                Home
                            </button>

                            <span className="text-[#B89442]/50">
                                /
                            </span>

                            <button
                                onClick={() => {
                                    if (room?.hotel?.slug) {
                                        navigate(`/hotels/${room.hotel.slug}`);
                                    } else {
                                        console.error("Hotel slug missing", room);
                                    }
                                }}
                                className="
                text-gray-600
                hover:text-[#0F766E]
                dark:text-gray-300
                dark:hover:text-[#B89442]
                transition
                font-medium
            "
                            >
                                {room.hotel?.name || "Hotel"}
                            </button>

                            <span className="text-[#B89442]/50">
                                /
                            </span>

                            <span className="
            text-gray-900
            dark:text-white
            font-semibold
        ">
                                Room {room.room_number}
                            </span>

                        </div>


                        {/* Back Button */}
                        <button
                            onClick={() => navigate(-1)}
                            className="
            flex 
            items-center 
            gap-2 
            text-sm 
            px-4
            py-2
            rounded-full
            bg-[#0F766E]/10
            text-[#0F766E]
            border
            border-[#0F766E]/20
            hover:bg-[#0F766E]
            hover:text-white
            dark:bg-[#B89442]/10
            dark:text-[#B89442]
            dark:border-[#B89442]/20
            dark:hover:bg-[#B89442]
            dark:hover:text-white
            transition-all
            duration-300
        "
                        >
                            <span className="text-lg">
                                ←
                            </span>

                            Back
                        </button>

                    </div>


                    {/* 🔹 HERO IMAGE */}
                    <div className="mt-6 relative">

                        <div className="relative group">

                            <img
                                src={`https://uaedubaihotels.com/uploads/rooms/${activeImage}`}
                                className="
        w-full
        h-[260px]
        sm:h-[350px]
        lg:h-[420px]
        object-cover
       rounded-[25px]
sm:rounded-[35px]
        shadow-2xl
    "
                                alt={`${room?.name || "Room"} main image`}
                            />


                            {/* Dark overlay */}
                            <div className="
            absolute 
            inset-0 
            bg-black/30 
            rounded-[35px]
        "></div>


                            {/* Content overlay */}
                            <div className="
            absolute 
            bottom-0 
            left-0 
            w-full 
           p-4
sm:p-6
            rounded-b-[35px]
            bg-gradient-to-t 
            from-black/85 
            via-black/40 
            to-transparent
        ">


                                <h1 className="
                text-white 
              text-xl
sm:text-2xl
md:text-3xl
                font-bold
            ">
                                    {room.room_number} ({room.name})
                                </h1>


                                <p className="
                text-white/70 
                text-sm 
                mt-1
            ">
                                    {room.hotel?.name}
                                </p>



                                {/* BADGES */}
                                <div className="flex gap-2 mt-4 flex-wrap">


                                    {isSeasonal && (
                                        <span
                                            className="
                            backdrop-blur-sm
                            border
                            border-[#B89442]/40
                            text-xs
                           px-2.5
py-1
sm:px-3
sm:py-1.5
                            rounded-full
                            font-semibold
                            shadow-md
                            flex
                            items-center
                            gap-1
                            transition
                            bg-[#B89442]
                            text-white
                        "
                                        >
                                            <FaFire />
                                            Limited Time Offer
                                        </span>
                                    )}



                                    {isDiscounted && (
                                        <span
                                            className="
                            bg-[#0F766E]/20
                            text-white
                            backdrop-blur-sm
                            border
                            border-[#0F766E]/50
                            text-xs
                            px-3
                            py-1.5
                            rounded-full
                            font-semibold
                            shadow-md
                            flex
                            items-center
                            gap-1
                            transition
                            hover:bg-[#0F766E]
                        "
                                        >
                                            <FaTag />
                                            {discountPercent}% OFF
                                        </span>
                                    )}


                                </div>




                                {/* Quick highlights */}
                                <div className="
    flex
    gap-2
    sm:gap-3
    mt-3
    sm:mt-4
    text-[11px]
    sm:text-xs
    text-white/80
    flex-wrap
">

                                    <span className="
                    bg-white/10
                    backdrop-blur-sm
                    px-3
                    py-1.5
                    rounded-full
                ">
                                        👤 {room.capacity} Guests
                                    </span>


                                    <span className="
                    bg-white/10
                    backdrop-blur-sm
                    px-3
                    py-1.5
                    rounded-full
                ">
                                        🛏 {room.bed_type}
                                    </span>


                                    <span className="
                    bg-white/10
                    backdrop-blur-sm
                    px-3
                    py-1.5
                    rounded-full
                ">
                                        📐 {room.size_sqm} m²
                                    </span>

                                </div>


                            </div>

                        </div>

                    </div>


                    {/* 🔹 IMAGE GALLERY */}
                    {allImages.length > 0 && (
                        <div className="mt-5">

                            <div className="
            flex 
            gap-3 
            overflow-x-auto 
            pb-2 
            scrollbar-hide
        ">

                                {allImages.map((img, i) => (
                                    <img
                                        key={i}
                                        onClick={() => {
                                            setModalIndex(i);
                                            setShowModal(true);
                                            setActiveImage(img);
                                        }}
                                        src={`https://uaedubaihotels.com/uploads/rooms/${img}`}
                                        className={`
                        w-28 
                        h-20 
                        object-cover
                        rounded-2xl
                        cursor-pointer
                        border-2
                        transition-all
                        duration-300
                        shadow-sm

                        ${activeImage === img
                                                ? `
                                    border-[#B89442]
                                    scale-105
                                    shadow-lg
                                    ring-2
                                    ring-[#B89442]/30
                                  `
                                                : `
                                    border-transparent
                                    hover:border-[#0F766E]/50
                                    hover:scale-105
                                  `
                                            }
                    `}
                                        alt={`Room thumbnail ${i + 1}`}
                                    />
                                ))}

                            </div>

                        </div>
                    )}


                    {/* 🔹 CONTENT */}
                    <div className="
    max-w-7xl 
    mx-auto 
    py-14
">

                        {/* LEFT */}
                        <div className="
        md:col-span-2 
        space-y-6
    ">


                            {/* TITLE */}
                            <div>

                                <h1 className="
                text-3xl 
                md:text-4xl 
                font-serif
                text-gray-900
                dark:text-white
            ">
                                    {room.room_number}
                                </h1>


                                <p className="
                text-gray-500 
                dark:text-gray-400
                mt-2
            ">
                                    Luxury stay with comfort & modern facilities
                                </p>

                            </div>




                            {/* INFO CARDS */}
                            <div className="
            grid 
            grid-cols-2 
            md:grid-cols-4 
            gap-3 
            sm:gap-4
        ">

                                {[
                                    { label: "Capacity", value: room.capacity },
                                    { label: "Bed Type", value: room.bed_type },
                                    { label: "Beds", value: room.beds_count },
                                    { label: "Size", value: `${room.size_sqm} m²` }
                                ].map((item, i) => (

                                    <div
                                        key={i}
                                        className="
                        bg-white
                        dark:bg-gray-900
                        border
                        border-[#DDD2BA]
                        dark:border-gray-800
                        p-5
                        rounded-[25px]
                        shadow-sm
                        text-center
                        transition-all
                        duration-300
                        hover:-translate-y-1
                        hover:shadow-lg
                    "
                                    >

                                        <p className="
                        text-sm
                        text-gray-500
                        dark:text-gray-400
                    ">
                                            {item.label}
                                        </p>


                                        <p className="
                        mt-2
                        font-bold
                        text-lg
                        text-[#0F766E]
                        dark:text-[#B89442]
                    ">
                                            {item.value || "-"}
                                        </p>


                                    </div>

                                ))}

                            </div>





                            {/* POLICIES */}
                            <div className="
            bg-white
            dark:bg-gray-900
            border
            border-[#DDD2BA]
            dark:border-gray-800
            p-6
            rounded-[30px]
            shadow-sm
        ">

                                <h2 className="
                text-xl
                font-semibold
                mb-4
                text-gray-900
                dark:text-white
            ">
                                    Policies
                                </h2>


                                <div className="
                grid
                md:grid-cols-2
                gap-4
                text-sm
                text-gray-600
                dark:text-gray-300
            ">


                                    <p>
                                        <b className="text-[#0F766E] dark:text-[#B89442]">
                                            Cancellation:
                                        </b>{" "}
                                        {room.cancellation_policy}
                                    </p>


                                    <p>
                                        <b className="text-[#0F766E] dark:text-[#B89442]">
                                            Availability:
                                        </b>{" "}
                                        {room.is_available ? "Available" : "Unavailable"}
                                    </p>


                                    <p>
                                        <b className="text-[#0F766E] dark:text-[#B89442]">
                                            Breakfast:
                                        </b>{" "}
                                        {room.breakfast_included ? "Included" : "Not Included"}
                                    </p>


                                    <p>
                                        <b className="text-[#0F766E] dark:text-[#B89442]">
                                            Smoking:
                                        </b>{" "}
                                        {room.smoking_allowed ? "Allowed" : "Not Allowed"}
                                    </p>


                                </div>

                            </div>


                            {/* AMENITIES */}
                            <div>
                                <h2 className="
        text-xl 
        font-semibold 
        mb-3
        text-gray-900
        dark:text-white
    ">
                                    Amenities
                                </h2>

                                <div className="flex flex-wrap gap-2">
                                    {amenities.length > 0 ? (
                                        amenities.map((a, i) => (
                                            <span
                                                key={i}
                                                className="
                        bg-[#0F766E]/10
                        text-[#0F766E]
                        border
                        border-[#0F766E]/20
                        dark:bg-[#0F766E]/20
                        dark:text-[#B89442]
                        dark:border-[#B89442]/30
                        px-4
                        py-1.5
                        rounded-full
                        text-sm
                        font-medium
                        transition-all
                        duration-300
                        hover:bg-[#0F766E]
                        hover:text-white
                        hover:border-[#0F766E]
                    "
                                            >
                                                {a}
                                            </span>
                                        ))
                                    ) : (
                                        <p className="text-gray-400">
                                            No amenities listed
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className={`${theme.soft} p-5 rounded-2xl`}>
                                <h3 className="font-semibold mb-2 text-blue-700 dark:text-cyan-400">Why choose this room?</h3>
                                <ul className="text-sm space-y-1 text-gray-700 dark:text-gray-300">
                                    <li>• Prime location</li>
                                    <li>• High guest rating</li>
                                    <li>• Best price guarantee</li>
                                </ul>
                            </div>

                            {/* DESCRIPTION */}
                            <div className="${theme.card} p-5 rounded-xl shadow">
                                <h2 className="text-xl font-semibold mb-2">Description</h2>
                                <div
                                    className="room-content prose max-w-none"
                                    dangerouslySetInnerHTML={{
                                        __html: (room.description || "")
                                            .replace('<h3>Rate Plan</h3>', '<h3 class="rate-plan">Rate Plan</h3>')
                                            .replace('<h3>Features</h3>', '<h3 class="features">Features</h3>')
                                    }}
                                />
                            </div>

                        </div>

                        {/* RIGHT BOOKING CARD */}
                        <div className="
    bg-white 
    dark:bg-gray-900 
    shadow-2xl 
    rounded-[35px] 
    p-6 
    border 
    border-[#DDD2BA] 
    dark:border-gray-800 
    sticky 
    top-24 
    mt-4
">

                            {/* Title */}
                            <h3 className="
        text-lg 
        font-semibold 
        text-gray-800 
        dark:text-white
    ">
                                Price Details
                            </h3>


                            <p className="
        text-xs 
        text-gray-500 
        dark:text-gray-400 
        mt-1
    ">
                                You won’t be charged yet
                            </p>



                            {/* PRICE */}
                            <div className="mt-4 flex items-end gap-2">

                                <h2 className="
            text-3xl 
            font-bold 
            text-[#B89442]
            dark:text-[#B89442]
        ">
                                    {checkIn && checkOut
                                        ? roundPrice(getFinalPriceBreakdown().total).toLocaleString()
                                        : getFinalRoomPrice(room).toLocaleString()}
                                </h2>

                                <span className="
            text-gray-500 
            dark:text-gray-400 
            mb-1
        ">
                                    AED
                                </span>

                            </div>



                            {/* Seasonal small message */}
                            {isSeasonal && (
                                <p className="
            text-xs 
            text-[#B89442]
            font-medium 
            mt-2 
            flex 
            items-center 
            gap-1
        ">
                                    <FiClock />
                                    Seasonal price (may change soon)
                                </p>
                            )}




                            {/* Seasonal Price */}
                            {isSeasonal && room?.seasonal_price && (
                                <p className="
            text-sm 
            text-[#0F766E]
            font-semibold 
            flex 
            items-center 
            gap-1
        ">
                                    <FaFire />
                                    Seasonal Deal: {Number(room.seasonal_price).toLocaleString()} AED
                                </p>
                            )}




                            {/* DISCOUNT */}
                            {isDiscounted && (
                                <div className="mt-3 space-y-1">


                                    <p className="text-sm">

                                        <span className="
                    font-semibold 
                    text-[#0F766E]
                    dark:text-[#B89442]
                ">
                                            {nightlyRate.toLocaleString()} AED
                                        </span>


                                        <span className="
                    text-gray-400 
                    line-through 
                    ml-2
                ">
                                            {Number(room.price).toLocaleString()} AED
                                        </span>

                                    </p>



                                    <p className="
                text-sm 
                text-[#0F766E]
                font-semibold 
                flex 
                items-center 
                gap-1
            ">
                                        <FaTag />
                                        You save {savedAmount.toLocaleString()} AED ({discountPercent}% OFF)
                                    </p>


                                </div>
                            )}





                            {/* Seasonal Box */}
                            {isSeasonal && (
                                <div className="
            mt-4
            p-4
            rounded-2xl
            bg-[#B89442]/10
            border
            border-[#B89442]/30
            shadow-sm
        ">

                                    <p className="
                text-sm
                text-[#B89442]
                font-semibold
                flex
                items-center
                gap-2
            ">
                                        <FaFire />
                                        Limited Time Seasonal Offer
                                    </p>


                                    <p className="
                text-xs
                text-gray-600
                dark:text-gray-300
                mt-1
                leading-relaxed
            ">
                                        Dynamic pricing applies — rates may change based on demand and availability.
                                    </p>

                                </div>
                            )}






                            {/* PRICE BREAKDOWN */}
                            <div className="
        mt-5 
        space-y-2 
        text-sm
    ">


                                <div className="
            flex 
            justify-between 
            text-gray-600 
            dark:text-gray-300
        ">

                                    <span>
                                        Base price (per night)
                                    </span>


                                    <span className="font-medium">

                                        {isDiscounted ? (
                                            <>
                                                <span className="
                            text-[#0F766E]
                            dark:text-[#B89442]
                        ">
                                                    {nightlyRate.toLocaleString()} AED
                                                </span>

                                                <span className="
                            text-xs 
                            text-gray-400 
                            line-through 
                            ml-2
                        ">
                                                    {Number(room.price).toLocaleString()} AED
                                                </span>
                                            </>
                                        ) : (
                                            `${nightlyRate.toLocaleString()} AED`
                                        )}

                                    </span>

                                </div>



                                <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                    <span>Service charge (10%)</span>
                                    <span>
                                        {roundPrice(nightlyRate * 0.10).toLocaleString()} AED
                                    </span>
                                </div>



                                <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                    <span>VAT (5%)</span>
                                    <span>
                                        {roundPrice(nightlyRate * 0.05).toLocaleString()} AED
                                    </span>
                                </div>



                                <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                    <span>
                                        Tourism fee
                                        {Number(room?.hotel?.rating) === 5 && " (5-Star Hotel Fee)"}
                                    </span>

                                    <span>
                                        {getTourismFee()} AED
                                    </span>
                                </div>



                                <hr className="my-3 border-[#DDD2BA]" />



                                <div className="
            flex 
            justify-between 
            font-semibold 
            text-gray-900 
            dark:text-white
        ">

                                    <span>
                                        Final price / night
                                    </span>


                                    <span className="
                text-[#B89442]
            ">
                                        {getFinalRoomPrice(room).toLocaleString()} AED
                                    </span>

                                </div>



                                {checkIn && checkOut && (
                                    <>

                                        <div className="
                    flex 
                    justify-between 
                    text-gray-700 
                    dark:text-gray-300
                    font-medium 
                    mt-2
                ">
                                            <span>Nights</span>
                                            <span>{getNights()}</span>
                                        </div>


                                        <div className="
                    flex 
                    justify-between 
                    text-lg 
                    font-bold 
                    text-[#0F766E]
                    dark:text-[#B89442]
                ">
                                            <span>Total</span>

                                            <span>
                                                {roundPrice(getFinalPriceBreakdown().total).toLocaleString()} AED
                                            </span>

                                        </div>

                                    </>
                                )}

                            </div>




                            {/* BUTTON */}
                            <button
                                onClick={() => setShowBookingModal(true)}
                                className="
            w-full
            mt-6
            py-3.5
            rounded-full
            bg-[#0F766E]
            hover:bg-[#B89442]
            text-white
            text-lg
            font-semibold
            shadow-lg
            hover:shadow-xl
            transition-all
            duration-300
        "
                            >
                                Reserve Now
                            </button>




                            {/* FOOTER NOTE */}
                            <p className="
        text-xs 
        text-gray-500 
        mt-3 
        text-center
    ">
                                {room.cancellation_policy === "free"
                                    ? "Free cancellation available"
                                    : "Cancellation policy applies"}
                            </p>


                        </div>

                    </div>

                    {showModal && (
                        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">

                            {/* Close */}
                            <button
                                onClick={() => setShowModal(false)}
                                className="absolute top-5 right-5 text-white text-3xl z-50"
                            >
                                ✕
                            </button>

                            {/* Prev */}
                            <button
                                onClick={() =>
                                    setModalIndex((prev) =>
                                        prev === 0 ? allImages.length - 1 : prev - 1
                                    )
                                }
                                className="absolute left-5 text-white text-5xl z-50 select-none"
                            >
                                ‹
                            </button>

                            {/* Next */}
                            <button
                                onClick={() =>
                                    setModalIndex((prev) =>
                                        prev === allImages.length - 1 ? 0 : prev + 1
                                    )
                                }
                                className="absolute right-5 text-white text-5xl z-50 select-none"
                            >
                                ›
                            </button>

                            {/* IMAGE WRAPPER (IMPORTANT PART) */}
                            <div className="flex items-center justify-center w-full h-full p-6">
                                <div className="max-w-4xl w-full max-h-[85vh] flex items-center justify-center">
                                    <img
                                        src={`https://uaedubaihotels.com/uploads/rooms/${allImages[modalIndex]}`}
                                        className="max-h-[85vh] w-[85vh] object-contain rounded-xl shadow-2xl"
                                        alt={`${room?.name || "Room"} image ${modalIndex + 1}`}
                                    />
                                </div>
                            </div>

                            {/* Counter */}
                            <div className="absolute bottom-5 text-white text-sm">
                                {modalIndex + 1} / {allImages.length}
                            </div>

                        </div>
                    )}

                    {showBookingModal && (
                        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3 sm:p-4 overflow-y-auto">

                            {/* Modal Box */}
                            <div className="
    room-modal
    bg-white
    dark:bg-gray-900
    rounded-[35px]
    shadow-2xl
    w-full
    max-w-2xl
    p-5
    sm:p-6
    relative
    max-h-[90vh]
    overflow-y-auto
    overflow-x-hidden
    min-w-0
    border
    border-[#DDD2BA]
    dark:border-gray-800
">

                                {/* Close */}
                                <button
                                    onClick={() => setShowBookingModal(false)}
                                    className="
absolute
top-4
right-4
text-gray-500
hover:text-[#B89442]
dark:hover:text-[#B89442]
text-xl
transition
"
                                >
                                    ✕
                                </button>

                                {/* Header */}
                                <h3 className="text-xl sm:text-2xl font-semibold">
                                    Complete your booking
                                </h3>

                                <p className="text-xs text-gray-500 mt-1">
                                    You won’t be charged yet — final price includes taxes & fees
                                </p>

                                {/* FORM */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5 w-full min-w-0 overflow-hidden">

                                    {/* Name */}
                                    <div>
                                        <label className="text-sm text-gray-600">Your Name</label>
                                        <input
                                            type="text"
                                            value={name}
                                            onChange={e => setName(e.target.value)}
                                            className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                        />
                                    </div>

                                    {/* Email */}
                                    <div>
                                        <label className="text-sm text-gray-600">Email</label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                        />
                                    </div>

                                    {/* Phone */}
                                    <div>
                                        <label className="text-sm text-gray-600">Phone</label>
                                        <input
                                            type="tel"
                                            value={phone}
                                            onChange={e => setPhone(e.target.value)}
                                            className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                        />
                                    </div>

                                    {/* Guests */}
                                    <div>
                                        <label className="text-sm text-gray-600">Guests</label>
                                        <input
                                            type="number"
                                            min="1"
                                            value={guests}
                                            onChange={e => setGuests(e.target.value)}
                                            className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                        />
                                    </div>


                                    {/* <div>
                                    <label className="text-sm text-gray-600">Check-in</label>
                                    <input
                                        type="date"
                                        value={checkIn}
                                        min={today}
                                        onChange={e => {
                                            setCheckIn(e.target.value);
                                            if (checkOut && e.target.value > checkOut) setCheckOut("");
                                        }}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                    />
                                </div>

                                
                                <div>
                                    <label className="text-sm text-gray-600">Check-out</label>
                                    <input
                                        type="date"
                                        value={checkOut}
                                        min={checkIn || today}
                                        onChange={e => setCheckOut(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-[#0F766E] outline-none box-border"
                                    />
                                </div> */}


                                    {/* Check-in */}
                                    <div className="w-full min-w-0 overflow-hidden">
                                        <label className="text-sm text-gray-600 block">
                                            Check-in
                                        </label>

                                        <input
                                            type="date"
                                            value={checkIn}
                                            min={today}
                                            onChange={e => {
                                                setCheckIn(e.target.value);

                                                if (checkOut && e.target.value > checkOut) {
                                                    setCheckOut("");
                                                }
                                            }}
                                            className="
    w-full
    h-[42px]
    min-w-0
    border
    border-[#DDD2BA]
    rounded-lg
    mt-1
    px-3
    text-sm
    focus:ring-2
    focus:ring-[#0F766E]
    outline-none
    box-border
"
                                        />
                                    </div>

                                    {/* Check-out */}
                                    <div className="w-full min-w-0 overflow-hidden">
                                        <label className="text-sm text-gray-600 block">
                                            Check-out
                                        </label>

                                        <input
                                            type="date"
                                            value={checkOut}
                                            min={checkIn || today}
                                            onChange={e => setCheckOut(e.target.value)}
                                            className="
    w-full
    h-[42px]
    min-w-0
    border
    border-[#DDD2BA]
    rounded-lg
    mt-1
    px-3
    text-sm
    focus:ring-2
    focus:ring-[#0F766E]
    outline-none
    box-border
"
                                        />
                                    </div>


                                </div>

                                {/* 🔥 PRICE BREAKDOWN */}
                                <div className="
mt-6
bg-[#FCFAF5]
dark:bg-gray-800
rounded-[25px]
p-5
border
border-[#DDD2BA]
">

                                    <p className="text-sm font-semibold text-gray-700">
                                        Price summary
                                    </p>

                                    <div className="mt-3 space-y-2 text-sm">

                                        {/* Base */}
                                        <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                            <span>Base price / night</span>
                                            <span>{nightlyRate.toLocaleString()} AED</span>
                                        </div>

                                        {/* VAT */}
                                        <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                            <span>VAT (5%)</span>
                                            <span>{roundPrice(nightlyRate * 0.05).toLocaleString()} AED</span>
                                        </div>

                                        {/* Service */}
                                        <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                            <span>Service charge (10%)</span>
                                            <span>{roundPrice(nightlyRate * 0.10).toLocaleString()} AED</span>
                                        </div>

                                        {/* Tourism */}
                                        <div className="flex justify-between text-gray-600 dark:text-gray-300">
                                            <span>
                                                Tourism fee
                                                {Number(room?.hotel?.rating) === 5 && " (5-Star Hotel Fee)"}
                                            </span>
                                            <span>{getTourismFee()} AED</span>
                                        </div>

                                        <hr className="my-2" />

                                        {/* Final per night */}
                                        <div className="flex justify-between font-semibold text-gray-800 dark:text-white">
                                            <span>Final price / night</span>
                                            <span className="text-[#B89442]
dark:text-[#B89442]">
                                                {getFinalRoomPrice(room).toLocaleString()} AED
                                            </span>
                                        </div>

                                        {/* Total */}
                                        {checkIn && checkOut && (
                                            <>
                                                <div className="flex justify-between text-gray-600 mt-2">
                                                    <span>Nights</span>
                                                    <span>{getNights()}</span>
                                                </div>

                                                <div className="flex justify-between text-lg font-bold text-gray-900 dark:text-white">
                                                    <span>Total</span>
                                                    <span>
                                                        {roundPrice(getFinalPriceBreakdown().total).toLocaleString()} AED
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Selected Room */}
                                <div
                                    className="
 mt-4 p-4 rounded-xl
 bg-gradient-to-r
 from-blue-50
 to-cyan-50
 dark:from-gray-900
 dark:to-gray-900
 border border-blue-100
 dark:border-gray-800
 "
                                >
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Selected Room</p>

                                    <p className="font-semibold text-lg">
                                        Room {room.room_number}
                                    </p>

                                    <p className="text-[#B89442]
dark:text-[#B89442] font-bold text-lg mt-1">
                                        {nightlyRate} AED
                                        <span className="text-sm font-normal text-gray-500">
                                            / per night
                                        </span>
                                    </p>

                                    {/*  DISCOUNT INFO */}
                                    {isDiscounted && (
                                        <p className="text-xs text-[#0F766E] mt-1">
                                            Discount applied — you save {savedAmount} AED per night
                                        </p>
                                    )}

                                    {/* 🔥 SEASONAL */}
                                    {isSeasonal && (
                                        <p className="text-xs text-orange-600 font-medium flex items-center gap-1 leading-relaxed">
                                            <FaFire className="text-[#B89442]" />
                                            Seasonal rate applied — pricing is limited-time and may change
                                        </p>
                                    )}
                                </div>

                                {/* BUTTON */}
                                <button
                                    onClick={handleBooking}
                                    disabled={bookingLoading}
                                    className={`
        w-full
        mt-6
        py-3.5
        rounded-full
        font-semibold
        text-white
        transition-all
        duration-300
        flex
        items-center
        justify-center
        gap-2
        shadow-lg
        ${bookingLoading
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-[#0F766E] hover:bg-[#B89442] hover:shadow-xl hover:-translate-y-0.5"
                                        }
    `}
                                >
                                    {bookingLoading ? (
                                        <>
                                            <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                            Processing...
                                        </>
                                    ) : (
                                        "Confirm Booking"
                                    )}
                                </button>

                            </div>
                        </div>
                    )}


                </div>
            </div>
        </>

    );


}